<template>
  <omint-page style="background: #f6f6f9">
    <Header
      name="ExternalLink"
      backRoute="/"
      titleLabel="Emissão de carta de permanência"
    />

    <OmtGrid class="external-link-page">
      <OmtRow>
        <OmtTypography
          as="h1-bold"
          mb="24px"
          >Emissão de carta de permanência</OmtTypography
        >
      </OmtRow>

      <OmtRow>
        <OmtTypography
          as="h2-bold"
          mb="16px"
          >Titular</OmtTypography
        >
      </OmtRow>

      <OmtRow
        :desktopEnd="6"
        mb="14px"
      >
        <TextTile
          :title="'Nome'"
          :description="requestData.titular.nome"
        />
      </OmtRow>
      <OmtRow
        :desktopStart="7"
        :desktopEnd="12"
        mb="14px"
      >
        <TextTile
          :title="'CPF'"
          :description="requestData.titular.cpf"
        />
      </OmtRow>
      <OmtRow
        :desktopEnd="6"
        mb="14px"
      >
        <TextTile
          :title="'RG'"
          :description="requestData.titular.rg"
        />
      </OmtRow>
      <OmtRow
        :desktopStart="7"
        :desktopEnd="12"
        mb="14px"
      >
        <TextTile
          :title="'Data ingresso'"
          :description="requestData.titular.dataIngresso"
        />
      </OmtRow>
      <OmtRow
        :desktopEnd="6"
        mb="14px"
      >
        <TextTile
          :title="'Título'"
          :description="requestData.titular.titulo"
        />
      </OmtRow>
      <OmtRow
        :desktopStart="7"
        :desktopEnd="12"
        mb="14px"
      >
        <TextTile
          :title="'Plano médico'"
          :description="requestData.titular.planoMedico"
        />
      </OmtRow>
      <OmtRow
        :desktopEnd="6"
        mb="16px"
      >
        <TextTile
          :title="'Plano odontológico'"
          :description="requestData.titular.planoOdontologico"
        />
      </OmtRow>

      <OmtRow>
        <CDivider
          mt="4px"
          mb="16px"
        />
      </OmtRow>

      <OmtRow>
        <OmtTypography
          as="h2-bold"
          mb="16px"
          >Beneficiários</OmtTypography
        >
      </OmtRow>

      <OmtRow>
        <div class="table-wrap">
          <table class="beneficiary-table">
            <thead>
              <tr>
                <th />
                <th>Nome</th>
                <th>Sequência</th>
                <th>Plano Médico</th>
                <th>Plano Odontológico</th>
                <th>Parentesco</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="beneficiario in requestData.beneficiarios"
                :key="beneficiario.id"
              >
                <td>
                  <input
                    v-model="beneficiario.selecionado"
                    type="checkbox"
                  />
                </td>
                <td>{{ beneficiario.nome }}</td>
                <td>{{ beneficiario.sequencia }}</td>
                <td>{{ beneficiario.planoMedico }}</td>
                <td>{{ beneficiario.planoOdontologico }}</td>
                <td>{{ beneficiario.parentesco }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </OmtRow>

      <OmtRow>
        <CDivider
          mt="20px"
          mb="16px"
        />
      </OmtRow>

      <OmtRow>
        <OmtTypography
          as="h2-bold"
          mb="8px"
          >Envio</OmtTypography
        >
      </OmtRow>
      <OmtRow>
        <OmtTypography
          as="p1"
          mb="8px"
        >
          Selecione sua preferência de e-mail para receber informações relacionadas a esta solicitação:
        </OmtTypography>
      </OmtRow>

      <OmtRow
        :desktopEnd="6"
        mb="20px"
      >
        <CBox mb="24px">
          <OmtTypography
            as="p2"
            mb="4px"
            >E-mail:</OmtTypography
          >
          <OmtSelect
            id="email-select"
            :initialValue="selectedEmail"
            placeholder="Selecione..."
            @change="onEmailChange"
          >
            <option
              v-for="mail in requestData.emailsDisponiveis"
              :key="mail"
              :value="mail"
            >
              {{ mail }}
            </option>
          </OmtSelect>
        </CBox>
      </OmtRow>

      <OmtRow mb="24px">
        <CBox class="notice-box">
          <OmtTypography
            as="p2"
            color="white"
            m="0"
          >
            Lembramos que você pode acompanhar esta solicitação através do link "minhas solicitações" localizado no menu
            lateral do Canal Exclusivo ou através do aplicativo Minha Omint ou ainda através de nossa Central de
            Atendimento que está à sua disposição 24h por dia, 07 dias por semana - 0800 726 4000.
          </OmtTypography>
        </CBox>
      </OmtRow>

      <OmtRow
        justify-content="center"
        mb="12px"
      >
        <OmtButton
          :isDisabled="isSubmitting || !selectedEmail"
          maxW="50%"
          @click="concluirSolicitacao"
        >
          {{ isSubmitting ? "Enviando..." : "Concluir" }}
        </OmtButton>
      </OmtRow>
    </OmtGrid>
  </omint-page>
</template>

<script>
import { GerarCartaPermanencia, ObterDadosCartaPermanencia } from "@/api/associado";
import Header from "@/components/Molecules/Header";
import TextTile from "@/components/Molecules/TextTile";
import { mapState } from "vuex";

export default {
  name: "ExternalLink",
  components: { Header, TextTile },
  computed: {
    ...mapState("saude", ["vinculo"])
  },
  data() {
    return {
      loading: false,
      isSubmitting: false,
      selectedEmail: "",
      requestData: {
        titular: {
          nome: "-",
          cpf: "-",
          rg: "-",
          dataIngresso: "-",
          titulo: "-",
          planoMedico: "-",
          planoOdontologico: "-"
        },
        beneficiarios: [],
        emailsDisponiveis: []
      }
    };
  },
  async mounted() {
    this.$root.$emit("show-back-button");
    this.$root.$emit("hide-header-options");
    try {
      this.$root.$emit("show-loading");
      await this.carregarDados();
    } catch (error) {
      console.error(error);
      this.$toast.open({
        message: "Não foi possível carregar os dados da carta de permanência.",
        type: "error"
      });
    } finally {
      this.$root.$emit("hide-loading");
    }
  },
  beforeDestroy() {
    this.$root.$emit("show-header-options");
    this.$root.$emit("show-back-button");
  },
  methods: {
    onEmailChange(email) {
      this.selectedEmail = email;
    },
    formatCpf(cpf) {
      const value = `${cpf || ""}`.replaceAll(/\D/g, "");
      if (value.length !== 11) return cpf || "-";
      return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },
    mapRequestData(payload) {
      const data = payload?.Data || {};
      const beneficiaries = (data.beneficiarios || []).map(item => ({
        id: item.Sequencia,
        nome: item.Nome,
        sequencia: item.Sequencia,
        planoMedico: item.PlanoMedico,
        planoOdontologico: `${item.Planoodonto || ""}`.trim(),
        parentesco: item.GrauParentesco,
        selecionado: true
      }));
      this.requestData = {
        titular: {
          nome: data.Nome || "-",
          cpf: this.formatCpf(data.Cpf),
          rg: data.Rg || "-",
          dataIngresso: "-",
          titulo: this.vinculo || "-",
          planoMedico: data.PlanoMedico || "-",
          planoOdontologico: `${data.Planoodonto || ""}`.trim() || "-"
        },
        beneficiarios: beneficiaries,
        emailsDisponiveis: data.Emails || []
      };
      this.selectedEmail = this.requestData.emailsDisponiveis[0] || "";
    },
    async carregarDados() {
      const response = await ObterDadosCartaPermanencia({
        vinculo: this.vinculo
      });
      if (response?.Data) {
        this.mapRequestData(response);
        return;
      }
      throw new Error("Não foi possível carregar os dados da carta de permanência.");
    },
    async concluirSolicitacao() {
      this.isSubmitting = true;
      try {
        const pdfBlobRequest = GerarCartaPermanencia({
          vinculo: this.vinculo,
          email: this.selectedEmail
        });
        window.open(pdfBlobRequest, "_blank");
      } catch (error) {
        console.error(error);
        this.$toast.open({
          message: "Não foi possível concluir a solicitação. Tente novamente.",
          type: "error"
        });
      } finally {
        this.isSubmitting = false;
      }
    }
  }
};
</script>
<style scoped>
.external-link-page {
  min-height: calc(100vh - 80px);
  padding: 16px 16px 32px;
}

.table-wrap {
  width: 100%;
  overflow-x: auto;
}

.beneficiary-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 760px;
}

.beneficiary-table th {
  background: #082a4b;
  color: #ffffff;
  text-align: left;
  padding: 14px 12px;
  font-size: 15px;
}

.beneficiary-table td {
  padding: 14px 12px;
  border-bottom: 1px solid #d4dbe2;
  color: #5d7893;
  font-size: 15px;
}

.notice-box {
  background: #9eafbf;
  padding: 14px 16px;
  border-radius: 4px;
}

@media (max-width: 768px) {
  .beneficiary-table th,
  .beneficiary-table td {
    font-size: 13px;
    padding: 10px 8px;
  }
}
</style>
